/*
 * The bar's shortcut answers to either modifier, so the hint has to name the one the viewer's
 * keyboard actually has rather than show both or guess. Read from the user agent string so the
 * branch stays a pure function of it, testable without a browser.
 */
const appleKeyboardPattern = /Mac|iPhone|iPad|iPod/i;

function isAppleKeyboard(userAgent: string): boolean {
  return appleKeyboardPattern.test(userAgent);
}

function readUserAgent(): string {
  let userAgent = '';
  if (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string') {
    userAgent = navigator.userAgent;
  }
  return userAgent;
}

function getShortcutLabel(userAgent: string): string {
  let label = 'Ctrl K';
  if (isAppleKeyboard(userAgent)) {
    label = '⌘K';
  }
  return label;
}

function getShortcutKeys(userAgent: string): string {
  let keys = 'Control+K';
  if (isAppleKeyboard(userAgent)) {
    keys = 'Meta+K';
  }
  return keys;
}

export { getShortcutKeys, getShortcutLabel, readUserAgent };
